import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button/custom-theme-button';
import SectionMessage from '@atlaskit/section-message';
import InfoIcon from '@atlaskit/icon/glyph/info';
import { commonMessages, overviewMessages } from '../../messages';
import StatefulInlineDialog from '../StatefulInlineDialog';
import UserInfo from '../UserInfo';
import * as Styled from './styled';
import { DropdownList } from '../DropdownList';
import MessagesIntlProvider from '../MessagesIntlProvider';
export var DeleteUserOverviewScreen = /*#__PURE__*/function (_React$Component) {
  _inherits(DeleteUserOverviewScreen, _React$Component);
  var _super = _createSuper(DeleteUserOverviewScreen);
  function DeleteUserOverviewScreen() {
    var _this;
    _classCallCheck(this, DeleteUserOverviewScreen);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "selectAdminOrSelfCopy", function (adminCopy, selfCopy) {
      return _this.props.isCurrentUser ? selfCopy : adminCopy;
    });
    _defineProperty(_assertThisInitialized(_this), "displayFirstListElement", function () {
      var _this$props = _this.props,
        accessibleSites = _this$props.accessibleSites,
        user = _this$props.user,
        isUserDeactivated = _this$props.isUserDeactivated;
      if (isUserDeactivated) {
        return null;
      }
      var hasAccessibleSites = accessibleSites && accessibleSites.length > 0;
      return /*#__PURE__*/React.createElement("li", null, !hasAccessibleSites && /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, _this.selectAdminOrSelfCopy(overviewMessages.paragraphLoseAccessAdminNoSites, overviewMessages.paragraphLoseAccessSelfNoSites), {
        values: {
          fullName: user.fullName,
          b: function b(s) {
            return /*#__PURE__*/React.createElement("b", null, s);
          }
        }
      })), hasAccessibleSites && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, _this.selectAdminOrSelfCopy(overviewMessages.paragraphLoseAccessAdmin, overviewMessages.paragraphLoseAccessSelf), {
        values: {
          fullName: user.fullName,
          b: function b(s) {
            return /*#__PURE__*/React.createElement("b", null, s);
          }
        },
        tagName: 'p'
      })), /*#__PURE__*/React.createElement(DropdownList, {
        accessibleSites: accessibleSites
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "displaySecondListElement", function () {
      return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, _this.selectAdminOrSelfCopy(overviewMessages.paragraphPersonalDataWillBeDeletedAdmin, overviewMessages.paragraphPersonalDataWillBeDeletedSelf), {
        values: {
          b: function b(s) {
            return /*#__PURE__*/React.createElement("b", null, s);
          }
        }
      })), /*#__PURE__*/React.createElement(Styled.IconHoverWrapper, null, /*#__PURE__*/React.createElement(StatefulInlineDialog, {
        placement: "auto-start",
        content: /*#__PURE__*/React.createElement(Styled.InlineDialogContent, null, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, _this.selectAdminOrSelfCopy(overviewMessages.inlineDialogDataWillBeDeletedP1Admin, overviewMessages.inlineDialogDataWillBeDeletedP1Self), {
          tagName: "p"
        })), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, _this.selectAdminOrSelfCopy(overviewMessages.inlineDialogDataWillBeDeletedLi1Admin, overviewMessages.inlineDialogDataWillBeDeletedLi1Self), {
          tagName: "li"
        })), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, _this.selectAdminOrSelfCopy(overviewMessages.inlineDialogDataWillBeDeletedLi2Admin, overviewMessages.inlineDialogDataWillBeDeletedLi2Self), {
          tagName: "li"
        })), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, _this.selectAdminOrSelfCopy(overviewMessages.inlineDialogDataWillBeDeletedLi3Admin, overviewMessages.inlineDialogDataWillBeDeletedLi3Self), {
          tagName: "li"
        })), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, _this.selectAdminOrSelfCopy(overviewMessages.inlineDialogDataWillBeDeletedP2Admin, overviewMessages.inlineDialogDataWillBeDeletedP2Self), {
          tagName: "p"
        })), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, _this.selectAdminOrSelfCopy(overviewMessages.inlineDialogDataWillBeDeletedP3Admin, overviewMessages.inlineDialogDataWillBeDeletedP3Self), {
          tagName: "p"
        })))
      }, /*#__PURE__*/React.createElement(InfoIcon, {
        label: "",
        size: "small"
      }))));
    });
    _defineProperty(_assertThisInitialized(_this), "displayThirdListElement", function () {
      return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedMessage, _this.selectAdminOrSelfCopy(overviewMessages.paragraphListOfAppsWithPersonalDataAdmin, overviewMessages.paragraphListOfAppsWithPersonalDataSelf)), /*#__PURE__*/React.createElement(Styled.IconHoverWrapper, null, /*#__PURE__*/React.createElement(StatefulInlineDialog, {
        placement: "auto-start",
        content: /*#__PURE__*/React.createElement(FormattedMessage, _this.selectAdminOrSelfCopy(overviewMessages.inlineDialogDataAppsAdmin, overviewMessages.inlineDialogDataAppsSelf))
      }, /*#__PURE__*/React.createElement(InfoIcon, {
        label: "",
        size: "small"
      }))));
    });
    _defineProperty(_assertThisInitialized(_this), "displayFourthListElement", function () {
      return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(FormattedMessage, _this.selectAdminOrSelfCopy(overviewMessages.paragraphContentCreatedAdmin, overviewMessages.paragraphContentCreatedSelf)), /*#__PURE__*/React.createElement(Styled.IconHoverWrapper, null, /*#__PURE__*/React.createElement(StatefulInlineDialog, {
        placement: "auto-start",
        content: /*#__PURE__*/React.createElement(FormattedMessage, _this.selectAdminOrSelfCopy(overviewMessages.inlineDialogContentCreatedAdmin, overviewMessages.inlineDialogContentCreatedSelf))
      }, /*#__PURE__*/React.createElement(InfoIcon, {
        label: "",
        size: "small"
      }))));
    });
    return _this;
  }
  _createClass(DeleteUserOverviewScreen, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        user = _this$props2.user,
        deactivateUserHandler = _this$props2.deactivateUserHandler,
        isUserDeactivated = _this$props2.isUserDeactivated;
      return /*#__PURE__*/React.createElement(MessagesIntlProvider, null, /*#__PURE__*/React.createElement(Styled.Screen, null, /*#__PURE__*/React.createElement(Styled.Title, null, /*#__PURE__*/React.createElement(FormattedMessage, this.selectAdminOrSelfCopy(overviewMessages.headingAdmin, overviewMessages.headingSelf))), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, this.selectAdminOrSelfCopy(overviewMessages.firstLineAdmin, overviewMessages.firstLineSelf), {
        tagName: "p"
      })), /*#__PURE__*/React.createElement(UserInfo, {
        user: user
      }), /*#__PURE__*/React.createElement(FormattedMessage, this.selectAdminOrSelfCopy(overviewMessages.paragraphAboutToDeleteAdmin, overviewMessages.paragraphAboutToDeleteSelf)), /*#__PURE__*/React.createElement(Styled.MainInformationList, null, this.displayFirstListElement(), this.displaySecondListElement(), this.displayThirdListElement(), this.displayFourthListElement()), deactivateUserHandler && /*#__PURE__*/React.createElement(Styled.SectionMessageOuter, null, /*#__PURE__*/React.createElement(SectionMessage, {
        appearance: "warning"
      }, /*#__PURE__*/React.createElement(FormattedMessage, isUserDeactivated ? overviewMessages.warningSectionBodyDeactivated : overviewMessages.warningSectionBody), !isUserDeactivated && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Button, {
        appearance: "link",
        spacing: "none",
        onClick: deactivateUserHandler
      }, /*#__PURE__*/React.createElement(FormattedMessage, commonMessages.deactivateAccount)))))));
    }
  }]);
  return DeleteUserOverviewScreen;
}(React.Component);
_defineProperty(DeleteUserOverviewScreen, "defaultProps", {
  isCurrentUser: false
});
export default DeleteUserOverviewScreen;